import DigitalGrow from './DigitalGrow';
import Mission from './Mission';
import Objectives from './Objectives';
import { Strategy } from './Strategy';
import { Team } from './Team';
import AnnualReport from './AnnualReport';
export class About {
    static fromApi(response) {
        const about = new About();
        if (response === null || response === void 0 ? void 0 : response.mission)
            about.mission = Mission.fromPartial(response === null || response === void 0 ? void 0 : response.mission);
        if (response === null || response === void 0 ? void 0 : response.strategy)
            about.strategy = Strategy.fromPartial(response === null || response === void 0 ? void 0 : response.strategy);
        if (response === null || response === void 0 ? void 0 : response.team)
            about.team = Team.fromPartial(response === null || response === void 0 ? void 0 : response.team);
        if (response === null || response === void 0 ? void 0 : response.digitalgrow)
            about.digitalGrow = DigitalGrow.fromPartial(response === null || response === void 0 ? void 0 : response.digitalgrow);
        if (response === null || response === void 0 ? void 0 : response.objectives)
            about.objectives = Objectives.fromPartial(response.objectives);
        if (response === null || response === void 0 ? void 0 : response.annual_report)
            about.annual_report = AnnualReport.fromPartial(response.annual_report);
        return about;
    }
    static fetchMission(response) {
        var _a, _b, _c, _d;
        const mission = new Mission();
        const translation = (_b = (_a = response === null || response === void 0 ? void 0 : response.mission) === null || _a === void 0 ? void 0 : _a.translations) === null || _b === void 0 ? void 0 : _b.pop();
        mission.text = (_c = translation === null || translation === void 0 ? void 0 : translation.mission_text) !== null && _c !== void 0 ? _c : '';
        mission.title = (_d = translation === null || translation === void 0 ? void 0 : translation.mission_title) !== null && _d !== void 0 ? _d : '';
        return mission;
    }
}
